import createStore from "astrid-helpers/src/createStore";

export const [getTheme, setTheme, useTheme] = createStore("light");
